/** 初回起動時の Loading 表示の上限時間 (ms) */
export const LoadingLimitMilliSecond = 2000;

/** メンテナンス表示 */
export const isMaintenance: boolean = false;
export const maintenanceStart: string | null = '2000-01-01T00:00:00+09:00';
export const maintenanceEnd: string | null = '2999-01-01T00:00:00+09:00';

/** インシデント表示 */
export const isIncident: boolean = false;

/** 事業者別の定数 */
export const PAIDY_ORG_ID = 43; // Paidy 事業者ID

/**
 * 使用をブロックするカメラのラベル一覧
 * https://liquidinc.atlassian.net/wiki/spaces/EKYC/pages/2697822312
 */
export const blockedCameraLabels = ['OBS Virtual Camera', 'Logi Capture', 'XSplit VCam', 'ManyCam'];
